<template>
  <question-base-wrapper
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ errors, failedRules }"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      :rules="validationRules ? validationRules.estimatedValue : 'required'"
    >
      <qz-number-input
        v-model.number="questionData[questionFields.estimatedValue]"
        :prefix="inputPrefix"
        :suffix="inputSuffix"
        :error-messages="getFieldErrors('estimatedValue', failedRules, errors)"
        :placeholder="helpers.getPlaceholderResponsiveText(placeholder || '', isMobile)"
        :maxlength="maxLength"
        :data-test="fieldTrackerId"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBaseNumber from './BaseNumber';
import QuestionBaseWrapper from './BaseWrapper';
import { snakeCase } from 'lodash';

export default {
  name: 'question-estimated-value',
  extends: QuestionBaseNumber,
  components: { QuestionBaseWrapper },
  data () {
    return {
      fields: ['estimatedValue'],
    };
  },
  computed: {
    fieldTrackerId () {
      return snakeCase(this.questionFields.estimatedValue);
    },
  },
  created () {
    this.questionData[this.questionFields.estimatedValue] = this.stepSharedData.estimatedValue || this.questionData[this.questionFields.estimatedValue];
    this.setVehicleLookupPrice();
  },
  watch: {
    'stepSharedData.estimatedValue': {
      handler: function () {
        this.questionData[this.questionFields.estimatedValue] = this.stepSharedData.estimatedValue;
        this.setVehicleLookupPrice();
      },
    },
    immediate: true,
  },
  methods: {
    setVehicleLookupPrice () {
      if (Object.prototype.hasOwnProperty.call(this.questionData, this.questionFields.vehicleLookupPrice)) {
        this.questionData[this.questionFields.vehicleLookupPrice] = this.stepSharedData.estimatedValue;
      }
    },
  },
};
</script>
